// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4bfba8386db8bd1951e09d33631f74bafc8b34c0/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};